import IlumaEvent from '@containers/IQOSUniverse/articles/IlumaEvent/IlumaEvent';
export default IlumaEvent;
